module.exports = __webpack_public_path__ + "img/pb_logo--desktop.4fe3cf64.svg";